"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendGuestJoinMail = exports.sendMailAboutEvaluations = exports.NotificationType = void 0;
/* eslint-disable no-redeclare */
/* eslint-disable @typescript-eslint/no-shadow */
var BaseFile_1 = require("@cck/common/dist/data/BaseFile");
var Evaluation_1 = require("@cck/common/dist/data/Evaluation");
var Staff_1 = require("@cck/common/dist/data/Staff");
var Translation_1 = require("@cck/common/dist/data/Translation");
var lodash_1 = __importDefault(require("lodash"));
var EvaluationLoader_1 = require("../evaluation/EvaluationLoader");
var EvaluationUtils_1 = require("../evaluation/EvaluationUtils");
var fbase_1 = require("../firebase/fbase");
var StaffManager = __importStar(require("../rcm/StaffManager"));
var StorageManager_1 = require("../storage/StorageManager");
var COLLECTION_NAME = 'NOTIFICATION';
exports.NotificationType = {
    Request: '1',
    Rejected: '2',
    Custom: '3',
    Join: '4' // GUEST -> STAFF
};
function getStaffInfoText(staffs, id, isOwner, controlId, staffToControl) {
    if (id in staffToControl) {
        if (!(controlId in staffToControl[id])) {
            staffToControl[id].push(controlId);
        }
    }
    else {
        staffToControl[id] = [controlId];
    }
    var staff = lodash_1.default.find(staffs, { id: id });
    return ((0, Translation_1.getKoName)('control', isOwner ? 'owner' : 'performer') +
        ': ' +
        (staff ? "".concat(staff.name, "(").concat(staff.departmentName, " / ").concat(staff.email, ")") : id));
}
function getFileInfoText(staffs, fileType, file) {
    if (file && file.state === BaseFile_1.FileState.OK) {
        var updater = (0, Staff_1.getStaffNameAndEmailById)(staffs, file.updater);
        return "".concat(fileType, "\uD30C\uC77C: ").concat(file.name, " - ").concat(updater, "\uC5D0 \uC758\uD574 ").concat(file.updateTime, "\uC5D0 \uC5C5\uB85C\uB4DC \uB428");
    }
    return "".concat(fileType, "\uD30C\uC77C: \uC5C6\uC74C");
}
function getFileInfosText(staffs, fileType, files) {
    if (files && !lodash_1.default.isEmpty(files)) {
        var text_1 = ["".concat(fileType, "\uD30C\uC77C:")];
        lodash_1.default.forEach(files, function (file, i) {
            var updater = (0, Staff_1.getStaffNameAndEmailById)(staffs, file.updater);
            text_1.push("[".concat(i + 1, "] ").concat(file.name, " - ").concat(updater, "\uC5D0 \uC758\uD574 ").concat(file.updateTime, "\uC5D0 \uC5C5\uB85C\uB4DC \uB428"));
        });
        return text_1;
    }
    return ["".concat(fileType, "\uD30C\uC77C: \uC5C6\uC74C")];
}
function createNotification(noti) {
    var _a, _b;
    return __awaiter(this, void 0, void 0, function () {
        var n2, n1t1, n1t2, subject, krEvaluationType, controlIdToDownloadUrl, refName, controlToNotification, staffToControl, staffs, result;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    n2 = '\n\n' // two new line
                    ;
                    n1t1 = '\n\t' // one new line, one tab
                    ;
                    n1t2 = '\n\t\t' // one new line, two tab
                    ;
                    if (noti.type === exports.NotificationType.Join) {
                        return [2 /*return*/, Promise.reject(new Error('잘못된 함수.'))];
                    }
                    krEvaluationType = (0, Evaluation_1.getKoEvaluation)(noti.evaluationType);
                    if (noti.type === exports.NotificationType.Request) {
                        // 평가 수행 요청
                        subject = "[".concat(krEvaluationType, "] (").concat(noti.evaluationName, ") \uD3C9\uAC00 \uC218\uD589\uD604\uD669 \uBC0F \uC218\uD589\uC644\uB8CC\uC694\uCCAD");
                    }
                    else if (noti.type === exports.NotificationType.Rejected) {
                        // 반려(재수행 요청)
                        subject = "[".concat(krEvaluationType, "] (").concat(noti.evaluationName, ") \uD3C9\uAC00 \uC7AC\uC218\uD589 \uC694\uCCAD(\uBC18\uB824)");
                    }
                    else if (noti.type === exports.NotificationType.Custom) {
                        // 제목, 코멘트가 넘어오는 커스텀 메일
                        subject = "[".concat(krEvaluationType, "] (").concat(noti.evaluationName, ") ").concat(noti.title);
                    }
                    else {
                        return [2 /*return*/, Promise.reject(new Error("Invalid noti type ".concat(noti)))];
                    }
                    controlIdToDownloadUrl = {};
                    refName = '';
                    if (!(noti.type === exports.NotificationType.Request && noti.evaluationItems[0].base.refEvaluationName)) return [3 /*break*/, 2];
                    refName = noti.evaluationItems[0].base.refEvaluationName;
                    return [4 /*yield*/, (0, StorageManager_1.getDownloadUrlFromArchive)(noti.evaluationType, refName, noti.controlIds)];
                case 1:
                    controlIdToDownloadUrl = _c.sent();
                    _c.label = 2;
                case 2:
                    controlToNotification = {};
                    staffToControl = {};
                    return [4 /*yield*/, StaffManager.getAll()];
                case 3:
                    staffs = (_c.sent());
                    // 컨트롤 돌면서 내용 만들기
                    lodash_1.default.forEach(noti.evaluationItems, function (item) {
                        var cycleName = item.content.control.cycleName.replace(/\n/g, ' ');
                        var categoryName = item.content.control.categoryName.replace(/\n/g, ' ');
                        var subCategoryName = item.content.control.subCategoryName.replace(/\n/g, ' ');
                        var narrative = item.content.control.narrative;
                        // comment 내용이 있으면 text 의 첫부분에 추가
                        var text = !lodash_1.default.isEmpty(noti.comment)
                            ? "".concat(noti.comment).concat(n2).concat(item.controlId, ": ").concat(item.content.control.name)
                            : "".concat(item.controlId, ": ").concat(item.content.control.name);
                        text += "".concat(n1t1, "\uAD00\uB828 \uBD84\uB958(\uB300\uBD84\uB958/\uC911\uBD84\uB958/\uC18C\uBD84\uB958): ").concat(cycleName, "/").concat(categoryName, "/").concat(subCategoryName);
                        text += "".concat(n1t1, "\uCEE8\uD2B8\uB864 \uC124\uBA85:");
                        lodash_1.default.split(narrative, '\r\n').forEach(function (splitNarrative) {
                            if (splitNarrative !== '') {
                                text += "".concat(n1t2).concat(splitNarrative);
                            }
                        });
                        text += n1t1 + getStaffInfoText(staffs, item.state.owner, true, item.controlId, staffToControl);
                        text +=
                            n1t1 + getStaffInfoText(staffs, item.state.performer, false, item.controlId, staffToControl);
                        text += "".concat(n1t1, "\uC0C1\uD0DC: ").concat((0, EvaluationUtils_1.progressStateToString)(item.state.state));
                        text += "".concat(n1t1).concat(getFileInfoText(staffs, BaseFile_1.FileType.Record, item.content.files.record));
                        if (noti.evaluationType === Evaluation_1.Type.Operation) {
                            text += "".concat(n1t1).concat(getFileInfoText(staffs, BaseFile_1.FileType.Population, item.content.files.population));
                            var evidenceText = lodash_1.default.join(getFileInfosText(staffs, BaseFile_1.FileType.Evidence, lodash_1.default.values(item.content.files.evidence)), n1t1);
                            text += "".concat(n1t1).concat(evidenceText);
                        }
                        var extraText = lodash_1.default.join(getFileInfosText(staffs, BaseFile_1.FileType.Extra, lodash_1.default.values(item.content.files.extra)), n1t1);
                        text += "".concat(n1t1).concat(extraText);
                        controlToNotification[item.controlId] = {
                            text: text,
                            url: lodash_1.default.get(controlIdToDownloadUrl, item.controlId, '')
                        };
                    });
                    result = {
                        type: noti.type,
                        subject: subject,
                        toObject: {},
                        refName: refName,
                        projectId: noti.projectId,
                        replyTo: lodash_1.default.isNil((_a = fbase_1.authService.currentUser) === null || _a === void 0 ? void 0 : _a.email) ? '' : (_b = fbase_1.authService.currentUser) === null || _b === void 0 ? void 0 : _b.email
                    };
                    lodash_1.default.forEach(staffToControl, function (controlIds, staffId) {
                        var text = '';
                        var checkMap = {};
                        var links = {};
                        lodash_1.default.forEach(controlIds, function (controlId) {
                            if (controlId in checkMap) {
                                return;
                            }
                            else {
                                checkMap[controlId] = true;
                            }
                            text = text + n2 + controlToNotification[controlId].text;
                            if (noti.type !== exports.NotificationType.Join &&
                                !lodash_1.default.isEmpty(refName) &&
                                !lodash_1.default.isNil(controlToNotification[controlId].url)) {
                                links[controlId] = controlToNotification[controlId].url;
                            }
                        });
                        var staff = lodash_1.default.find(staffs, { id: staffId });
                        result.toObject[staff ? staff.email : staffId] = { text: text, linkObject: links };
                    });
                    return [4 /*yield*/, fbase_1.dbService.collection(COLLECTION_NAME).add(result)];
                case 4:
                    _c.sent();
                    return [2 /*return*/];
            }
        });
    });
}
function sendMailAboutEvaluations(notificationType, evaluationType, evaluationName, controlIds, extraComment, projectId, title) {
    return __awaiter(this, void 0, void 0, function () {
        var notification, items;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    notification = {
                        type: notificationType,
                        evaluationType: evaluationType,
                        evaluationName: evaluationName,
                        evaluationItems: [],
                        controlIds: controlIds,
                        comment: extraComment,
                        projectId: projectId,
                        title: title
                    };
                    return [4 /*yield*/, (0, EvaluationLoader_1.getEvaluationItems)(evaluationType, evaluationName)];
                case 1:
                    items = _a.sent();
                    notification.evaluationItems = lodash_1.default.filter(items, function (evaluation) {
                        return lodash_1.default.includes(controlIds, evaluation.controlId);
                    });
                    notification.projectId = projectId;
                    return [4 /*yield*/, createNotification(notification)];
                case 2:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
exports.sendMailAboutEvaluations = sendMailAboutEvaluations;
function sendGuestJoinMail(staffIds, projectId) {
    return __awaiter(this, void 0, void 0, function () {
        var result, n1t1, staffs;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    /*
                    관리자에 의해 GUEST 가 STAFF 로 업그레이드 되면 완료되었다는 메일을 발송
                  
                    type: "3"
                  
                    @param: staffIdList: String[] - STAFF id list
                    */
                    if (staffIds.length === 0) {
                        return [2 /*return*/, Promise.reject(new Error('해당하는 staffId 가 없습니다.'))];
                    }
                    result = {
                        type: exports.NotificationType.Join,
                        subject: '회원가입이 승인되었습니다.',
                        toObject: {},
                        refName: '',
                        projectId: projectId
                    };
                    n1t1 = '\n\t' // one new line, one tab
                    ;
                    return [4 /*yield*/, StaffManager.getAll()];
                case 1:
                    staffs = _a.sent();
                    lodash_1.default.forEach(staffIds, function (id) {
                        var staff = lodash_1.default.find(staffs, { id: id });
                        var text = "".concat(staff.name, "(").concat(staff.email, ") \uB2D8\uC758 \uAC00\uC785\uC774 \uC2B9\uC778 \uCC98\uB9AC\uB418\uC5C8\uC2B5\uB2C8\uB2E4.") +
                            "".concat(n1t1, "\uC544\uC774\uB514: ").concat(staff.email) +
                            "".concat(n1t1, "\uC774\uB984: ").concat(staff.name) +
                            "".concat(n1t1, "\uBD80\uC11C: ").concat(staff.departmentName);
                        result.toObject[staff.email] = {
                            linkObject: {},
                            text: text
                        };
                    });
                    return [4 /*yield*/, fbase_1.dbService.collection(COLLECTION_NAME).add(result)];
                case 2:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
}
exports.sendGuestJoinMail = sendGuestJoinMail;
//# sourceMappingURL=MailManager.js.map